import { render, staticRenderFns } from "./SharedNotificationDetailView.vue?vue&type=template&id=f4573a56&scoped=true"
import script from "./SharedNotificationDetailView.vue?vue&type=script&lang=js"
export * from "./SharedNotificationDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4573a56",
  null
  
)

export default component.exports